var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useItemEditor } from "./useItemEditor";
export var useContributionEditor = function (_a) {
    var existingCount = _a.existingCount, appendContribution = _a.appendContribution, updateContribution = _a.updateContribution;
    var _b = useItemEditor({
        appendItem: appendContribution,
        updateItem: updateContribution,
        createEmpty: function () { return ({
            sequenceNumber: Math.max(1, existingCount + 1),
            firstName: "",
            lastName: "",
            biographicalNote: "",
            name: "",
            roles: [],
        }); },
    }), isOpen = _b.isOpen, editingIndex = _b.editingIndex, draft = _b.draft, setDraft = _b.setDraft, openEditor = _b.openEditor, closeEditor = _b.closeEditor, saveItem = _b.saveItem;
    var addContributionRole = function (role) {
        setDraft(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), { roles: __spreadArray(__spreadArray([], ((_a = prev.roles) !== null && _a !== void 0 ? _a : []), true), [{ role: role }], false) }));
        });
    };
    var removeContributionRole = function (roleIndex) {
        setDraft(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), { roles: ((_a = prev.roles) !== null && _a !== void 0 ? _a : []).filter(function (_, i) { return i !== roleIndex; }) }));
        });
    };
    var updateContributionRole = function (roleIndex, role) {
        setDraft(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), { roles: ((_a = prev.roles) !== null && _a !== void 0 ? _a : []).map(function (r, i) {
                    return i === roleIndex ? { role: role } : r;
                }) }));
        });
    };
    return {
        showContributionForm: isOpen,
        editingContributionIndex: editingIndex,
        contributionFormData: draft,
        setContributionFormData: setDraft,
        openContributionForm: openEditor,
        closeContributionForm: closeEditor,
        saveContribution: saveItem,
        addContributionRole: addContributionRole,
        removeContributionRole: removeContributionRole,
        updateContributionRole: updateContributionRole,
    };
};
